import type { DialoguePool } from '@/state/types';

export const L11_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Found it yet? Check under the \u2018Regret\u2019 pile.',
    'None of these are it. That is part of the design.',
    'I will log every click under the denial column.',
  ],
  tokenLoss: [
    'Another wrong square. Token recycled to \u2018participation trophy\u2019 fund.',
    'A futile gesture. Token removed for clerical neatness.',
    'The grid is decorative. The token is gone. Balance, in a sense.',
  ],
  solution: [
    'Thrown away. Where it belongs. Next level. Quickly.',
    'It\u2019s amazing how much space that was taking up. Like a piano in a phone box.',
    'I\u2019d applaud, but I\u2019m currently occupied by the sheer pointlessness of it all.',
  ],
  spite: [
    'The bin remembers. It\u2019s kept a receipt. Don\u2019t read it.',
  ],
};
